import {useMemo} from 'react';

import {useDocumentContext} from '@/components/document/context';
import {useDocumentStore} from '@/components/document/store';

export const useInvalidSectionFields = (): Set<string> => {
  const {documentModel, currentSectionId} = useDocumentContext();

  const dependentSectionIds = useMemo(
    () => documentModel.sections.find(section => section.id === currentSectionId)?.displayWith ?? [],
    [documentModel, currentSectionId],
  );

  // Only subscribe to the validity of the current and dependent sections so that
  // validation of unrelated sections does not re-render every consumer.
  const sectionsValidity = useDocumentStore(state =>
    [currentSectionId, ...dependentSectionIds].map(sectionId => state.validity[sectionId]),
  );

  return useMemo(() => {
    const invalidFields = new Set<string>();

    for (const sectionValidity of sectionsValidity) {
      if (!sectionValidity) continue;

      for (const [fieldId, fieldValidity] of Object.entries(sectionValidity.fields)) {
        if (fieldValidity?.valid === false) invalidFields.add(fieldId);
      }
    }

    return invalidFields;
  }, [sectionsValidity]);
};
